import { useQuery } from '@tanstack/react-query';
import { fetchAttendance } from 'src/api/attendanceAPI';
import { fetchClassById } from 'src/api/classAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import { fetchSigningFormByClassAndStudent } from 'src/api/signingFormAPI';
import { fetchMyUser } from 'src/api/userAPI';
import Attendance from 'src/models/Attendance';
import { Class } from 'src/models/classes';
import SigningForm from 'src/models/SigningForm';
import { User } from 'src/models/user';

interface StudentAttendancePageState {
  user: User;
  class: Class;
  signingForm: SigningForm | null;
  attendance: Attendance[];
}

export function useStudentAttendancePageData(classId: number) {
  return useQuery<StudentAttendancePageState, ApiError>({
    queryKey: ['useStudentAttendancePageData', classId],
    queryFn: async () => {
      const user = await fetchMyUser();
      const [classData, attendance] = await Promise.all([
        fetchClassById(classId),
        fetchAttendance({ classId, studentUserId: user.id }),
      ]);

      let signingForm: SigningForm | null = null;
      try {
        signingForm = await fetchSigningFormByClassAndStudent(classId, user.id);
      } catch (error) {
        const apiError = error as ApiError;
        if (apiError.statusCode !== 404) throw apiError;
      }

      return { user, class: classData, signingForm, attendance };
    },
  });
}
